import axios from "../utils/axios";

export const getAssemblyResponsibles = () => {
    return axios.get(`/ServiceVendors`);
};

export const getServiceOrder = (id) => {
    return axios.get(`/UnplannedMaintenance/tasks/${id}/service-orders`);
};

export const saveServiceOrder = (payload) => {
    return axios.post(`/UnplannedMaintenance/tasks/${payload.taskId}/service-orders`, payload);
};

export const getServiceOrderPlanned = (id) => {
    return axios.get(`/PlannedMaintenance/tasks/${id}/service-orders`);
};

export const saveServiceOrderPlanned = (payload) => {
    return axios.post(`/PlannedMaintenance/tasks/${payload.taskId}/service-orders`, payload);
};